import { initialAgent } from "../types/Agent"
import { Action, State, StateAction } from "../types/State"

const initialCall = {
  id: "",
  startedAt: new Date(),
}

export const initialState: State = {
  user: null,
  audioEnabled: true,
  videoEnabled: true,
  audioDevice: null,
  videoDevice: null,
  stream: null,
  call: initialCall,
  agent: initialAgent,
}

export const appReducer = (state: State, action: Action): State => {
  let audioEnabled
  let videoEnabled
  let stream
  let track
  switch (action.type) {
    case StateAction.setUser:
      return { ...state, user: action.payload }
    case StateAction.end:
      return {
        ...state,
        audioEnabled: true,
        videoEnabled: true,
        stream: null,
      }
    case StateAction.toggleAudio:
      stream = state.stream
      audioEnabled = state.audioEnabled
      track = stream?.getAudioTracks?.()[0]
      if (track != null) {
        audioEnabled = !audioEnabled
        track.enabled = audioEnabled
      }
      return { ...state, audioEnabled: audioEnabled, stream: stream }
    case StateAction.toggleVideo:
      stream = state.stream
      videoEnabled = state.videoEnabled
      track = stream?.getVideoTracks?.()[0]
      if (track != null) {
        videoEnabled = !videoEnabled
        track.enabled = videoEnabled
      }
      return { ...state, videoEnabled: videoEnabled, stream: stream }
    case StateAction.setAudioDevice:
      return { ...state, audioDevice: action.payload }
    case StateAction.setVideoDevice:
      return { ...state, videoDevice: action.payload }
    case StateAction.setStream:
      return {
        ...state,
        stream: action.payload,
      }
    case StateAction.setCall:
      return { ...state, call: action.payload }
    case StateAction.setAgent:
      return { ...state, agent: action.payload }
    case StateAction.resetAgentAndCall:
      return {
        ...state,
        call: initialCall,
        agent: initialAgent,
      }
    case StateAction.resetState:
      return initialState
    default:
      console.log("Invalid action type", JSON.stringify(action))
      throw new Error("Invalid action type")
  }
}
